import React from 'react'
import { gaTrack, facebookAppId} from 'shared/sharing_helper'
import { FacebookButton, TwitterButton, EmailButton, WhatsappButton, FacebookMessengerButton } from 'betterplace-react-share'
import '../../../node_modules/betterplace-react-share/dist/index.css'

export class ShareButtons extends React.Component {

  utmParams = (platform) => {
    return {
      utm_campaign: 'user_share',
      utm_medium: `${this.props.gaLabel}`,
      utm_source: platform.split('_').map(x => x.charAt(0).toUpperCase() + x.slice(1)).join(' ')
    }
  }

  buttonContent = (platform) => {
    if (this.props.fundraisingEvent) {
      return I18n.t(`fundraising_events.show.sharing.${platform}_link`)
    } else {
      return I18n.t(`projects.show.share_buttons.${platform}_share_label`)
    }
  }

  buttonTeaser = () => {
    if (this.props.fundraisingEvent) {
      return I18n.t('fundraising_events.show.sharing.teaser')
    } else {
      return I18n.t('projects.show.share_buttons.teaser')
    }
  }

  buttonProps = (platform) => {
    const {mobileOnly, gaLabel, shareUrl, shape } = this.props
    return {
      shape,
      shareUrl,
      additionalClass:  mobileOnly && mobileOnly.includes(platform) ? 'mobile-only-flex' : '',
      utmParams: this.utmParams(platform),
      beforeOnClick: () => gaTrack(platform, shareUrl, gaLabel),
      title:  this.buttonContent(platform),
      content:  this.buttonContent(platform),
      teaser: this.buttonTeaser()
    }
  }

  render() {

    if (this.props.status == 'blocked' || this.props.status == 'preparing') return null
      const { mobileOnly, gaLabel, children, additionalClass, shareUrl, shape, platforms } = this.props

    return <ul className={ `generic-social-sharing list-unstyled ${additionalClass || ''}` }>
      {children}

      {platforms.includes('facebook') && <FacebookButton {...this.buttonProps('facebook')} /> }

      {platforms.includes('twitter') && <TwitterButton {...this.buttonProps('twitter')}/> }

      {platforms.includes('email') && <EmailButton {...this.buttonProps('email')} teaser={I18n.t('projects.show.share_buttons.email_share_subject')}/>}

      {platforms.includes('whatsapp') && <WhatsappButton {...this.buttonProps('whatsapp')} />}

      {platforms.includes('messenger') && <FacebookMessengerButton facebookAppId={facebookAppId()} {...this.buttonProps('messenger')} /> }
    </ul>
  }
}
